import SampleModel from "@/models/lab/SampleModel";
import LabServiceCollection from "@/collections/LabServiceCollection";

export default class SampleCollection extends LabServiceCollection {

  options() {
    const options = super.options() || {};
    options.methods = this.methods();

    return options;
  }

  model() {
    return SampleModel;
  }

  methods() {
    return {
      fetch: "GET",
      fetchByLatestStatus: "GET",
      fetchAllocatableForPrep: "GET",
      save: "POST",
      delete: "DELETE"
    }
  }

  routes() {
    const model = (new (this.model())());
    const routes = super.routes();

    routes['fetchByLatestStatus'] = `${process.env.VUE_APP_LAB_REPOSITORY_URL}/api/v1/${model.modelName()}/sample-status/{sample_status}/latest`;
    routes['fetchAllocatableForPrep'] = `${process.env.VUE_APP_LAB_REPOSITORY_URL}/api/v1/${model.modelName()}/allocatable-prep/{prep_work_flow}`;

    return routes;
  }

  fetchByLatestStatus(sample_status, params) {
    const method = this.getOption('methods.fetchByLatestStatus');
    const route = this.getRoute('fetchByLatestStatus');

    if(sample_status.id) {
      const url = this.getURL(route, { sample_status: sample_status.id });
      
      return this.createRequest({method, url, params}).send()
        .then(this.handleCustomFetchSuccess)
        .catch(this.handleCustomFetchFailure);
    }

    return null;
  }
}
